import { render, staticRenderFns } from "./commissionList.vue?vue&type=template&id=255ec005&scoped=true&"
import script from "./commissionList.vue?vue&type=script&lang=js&"
export * from "./commissionList.vue?vue&type=script&lang=js&"
import style1 from "./commissionList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255ec005",
  null
  
)

export default component.exports